import { ReactNode, ReactElement, FunctionComponent } from "react";

interface CaseProps {
  value: any;
  children: ReactNode;
}

const Case: FunctionComponent<CaseProps> = ({ children }) => <>{children}</>;

interface DefaultProps {
  children: ReactNode;
}

const Default: FunctionComponent<DefaultProps> = ({ children }) => <>{children}</>;

interface SwitchProps {
  on: any;
  children: ReactElement[];
}

const isComponentType = (component: ReactElement, name: string): boolean => {
  return (component.type as any)?.name === name;
};

const Switch: FunctionComponent<SwitchProps> = ({ on, children }) => {
  if (!children) {
    throw new Error("<Switch/> requires at least one <Case/> child component");
  }

  const arrChildren = Array.isArray(children) ? children : [children];
  const badChild = arrChildren.find(
    (child) =>
      !["Case", "Default"].includes(
        isComponentType(child, "Case") || isComponentType(child, "Default") ? (child.type as any)?.name : "",
      ),
  );

  if (badChild) {
    throw new Error(`<Switch /> must only contain <Case/> children. Please wrap <${badChild.type}/> in a <Case/>`);
  }

  const firstMatch = arrChildren.find((child) => {
    const { value } = child.props as CaseProps;
    if (Array.isArray(value)) return value.includes(on);
    return value === on;
  });

  if (firstMatch) return firstMatch;

  const defaultComp = arrChildren.find((child) => isComponentType(child, "Default"));
  return defaultComp || null;
};

export { Switch, Case, Default };
